 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTHALFTITLE from '@/components/Text/HalfTitle'
 import TEXTFULLTITLE from '@/components/Text/FullTitle'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTTOC from '@/components/Text/ToC'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTHALFTITLE2 from '@/components/Text/HalfTitle2'
 import TEXTSCRPP1 from '@/components/Text/SCRPp1'
 import TEXTSCRPP2 from '@/components/Text/SCRPp2'
 import TEXTSCRPP3 from '@/components/Text/SCRPp3'
 import TEXTSCRPP4 from '@/components/Text/SCRPp4'
 import TEXTSCRPP5 from '@/components/Text/SCRPp5'
 import TEXTSCRPP6 from '@/components/Text/SCRPp6'
 import TEXTSCRPP7 from '@/components/Text/SCRPp7'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import TEXTABBREVIATIONS from '@/components/Text/Abbreviations'
 import TEXTCOLORAPPENDIX from '@/components/Text/ColorAppendix'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTBIBLIOGRAPHY from '@/components/Text/Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/ToC",
 			"name" : "Text/ToC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/HalfTitle2",
 			"name" : "Text/HalfTitle2",
 			"component" : TEXTHALFTITLE2
 		},
 		{
 			"path" : "/Text/SCRPp1",
 			"name" : "Text/SCRPp1",
 			"component" : TEXTSCRPP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js